import {
    IDynamicFormRow,
    FormTextBox,
    FormSelect,
    FormTextArea,
} from '@src/components/ui';
import { TFunction } from 'i18next';

const category: { label: string; value: number | string }[] = [
    { value: 'ACCOUNT_ACCESS_ISSUES', label: 'Account & Access Issues' },
    {
        value: 'ORDERING_PURCHASING',
        label: 'Ordering & Purchasing',
    },
    {
        value: 'ESIM_DELIVERY',
        label: 'eSIM Delivery',
    },
    {
        value: 'ESIM_ACTIVATION',
        label: 'eSIM Activation & Usage',
    },
    {
        value: 'TOP_UP',
        label: 'Top-up Related',
    },
    {
        value: 'PARTNERSHIP',
        label: 'Partnership & Business Requests',
    },
    {
        value: 'OTHER',
        label: 'Other',
    },
];
export function supportSchema(
    t: TFunction<'translation', undefined>
): IDynamicFormRow[] {
    return [
        {
            label: t('forms.email'),
            keyName: 'email',
            inputProperties: {
                placeholder: t('forms.email'),
                type: 'email',
            },
            Component: FormTextBox,
            registerOptions: {
                required: {
                    value: true,
                    message: t('errors.formErrors.required', {
                        name: t('forms.email'),
                    }),
                },
            },
        },
        {
            label: t('pages.support.category'),
            keyName: 'category',
            Component: FormSelect,
            formProps: {
                selectOptions: category,
                placeholder: t('pages.support.selectCategory'),
            },
            registerOptions: {
                required: {
                    value: true,
                    message: t('errors.formErrors.required', {
                        name: t('pages.support.category'),
                    }),
                },
            },
        },
        {
            label: t('pages.support.message'),
            keyName: 'message',
            Component: FormTextArea,
            formProps: {
                placeholder: t('pages.support.messagePlaceholder'),
            },
            registerOptions: {
                required: {
                    value: true,
                    message: t('errors.formErrors.required', {
                        name: t('pages.support.message'),
                    }),
                },
            },
        },
    ];
}